import { apiService } from './api';
import { getUserInfo } from '../utils/auth';

      
export const postService = {


  getById: async (id) => {
    try {
      const response = await apiService.get(`/post/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post');
    }
  },

  create: async (postData) => {
    try {
       const userinfo = getUserInfo();
      postData.userId = userinfo.user.id;
      const response = await apiService.post('/post/create', postData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create post');
    }
  },

  update: async (id, postData) => {
    try {
      const userinfo = getUserInfo();
      postData.userId = userinfo.user.id;
      const response = await apiService.put(`/post/${id}`, postData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update post');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/post/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete post');
    }
  },

  getPostWithContent: async (id) => {
    try {
      const response = await apiService.get(`/post/contents/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },

  getAdminArticle: async () => {
    try {
      const response = await apiService.get('/posts/admin');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch posts');
    }
  },

  getPaginatedAdminPosts: async (page = 1, pageSize = 10, categoryId = null, search = '') => {
      try {
          let url = `/posts/admin/paginated?page=${page}&pageSize=${pageSize}`;
          if (categoryId) url += `&categoryId=${categoryId}`;
          if (search) url += `&search=${encodeURIComponent(search)}`;
          
          const response = await apiService.get(url);
          return response.data; // Returns ResponseModel with Data and Pagination
      } catch (error) {
          throw new Error(error.response?.data?.message || 'Failed to fetch posts');
      }
    },


    getDisplayOrderByCategory: async (id) => {
    try {
      const response = await apiService.get(`/displayorder/category/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },


//admin end


  createPostContent: async (contentData) => {
    try {
      const response = await apiService.post('/PostContentBlock/create', contentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create post content');
    }
  },
  getPostContent: async (id) => {
    try {
      const response = await apiService.get(`/PostContentBlock/post/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },
  updatePostContent: async (id, contentData) => {
    try {
      const response = await apiService.put(`/PostContentBlock/${id}`, contentData);
      return response.data;
    } catch (error) { 
      throw new Error(error.response?.data?.message || 'Failed to update post content');
    }
  },




  getArticleSummary: async () => {
    try {
      const response = await apiService.get('/tutorials/summary');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch posts');
    }
  },


  getTutorialsByCategory: async (id) => {
    try {
      const response = await apiService.get(`/tutorials/category/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },


  searchTutorials: async (query) => {
    try {
      const response = await apiService.get(`/tutorials/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Failed to search tutorials:', error);
      throw error;
    }
  },



  searchBlogs: async (query) => {
    try {
      const response = await apiService.get(`/blogs/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Failed to search tutorials:', error);
      throw error;
    }
  },

  getHomeArticals: async () => {
    try {
      const response = await apiService.get('/blogs/home');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch posts');
    }
  },

};
